@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }} @if (control && control.hasValidator(Validators.required)) {
    <span class="text-red-600">*</span>
  }
  </label>
}
<div class="relative">
  <input
    (change)="$event.stopPropagation();changed($event)"
    (blur)="control.markAsTouched()"
    [name]="name"
    #timePicker
    onclick="this.showPicker()" type="time" placeholder="12:00 AM"
    class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full appearance-none rounded-lg border border-gray-300 bg-transparent bg-none px-4 py-2.5 pr-11 pl-4 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30">
  <span (click)="$event.stopPropagation();timePicker.click()" class="cursor-pointer absolute top-1/2 right-3 -translate-y-1/2 text-gray-500 dark:text-gray-400">
    <lucide-icon size="18" [name]="Clock"></lucide-icon>
  </span>
</div>

@if (control.invalid && (control.dirty || control.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
      @if (control.errors) {
        <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
      }
    }
  </p>
}
